export default {
  getError: state => {
    return state.error;
  },
};
